import { SiteSectionIds } from '../../../../contentful/constants';
import { AirportCodes } from '../../../../types/airports';

const siteSectionIdToAirportCodeMap: {
	[key in SiteSectionIds]?: AirportCodes;
} = {
	[SiteSectionIds.IAH]: AirportCodes.IAH,
	[SiteSectionIds.HOU]: AirportCodes.HOU,
	[SiteSectionIds.EFD]: AirportCodes.EFD,
	[SiteSectionIds.Spaceport]: AirportCodes.Spaceport,
	[SiteSectionIds.Corporate]: AirportCodes.Corporate,
};

export const getCurrentAirportCodeFromId = (
	currentSiteSectionId?: string | SiteSectionIds,
): AirportCodes =>
	siteSectionIdToAirportCodeMap[currentSiteSectionId as SiteSectionIds] ||
	siteSectionIdToAirportCodeMap[SiteSectionIds.IAH]!;

const airportCodeMap: { [key: string]: AirportCodes } = {
	iah: AirportCodes.IAH,
	hou: AirportCodes.HOU,
	ellington: AirportCodes.EFD,
	spaceport: AirportCodes.Spaceport,
	'airport-business': AirportCodes.Corporate,
};

export const getCurrentAirportCodeFromSlug = (slug: string) => {
	const parts = slug.split('/');
	const airportCodeSlug = parts[1]?.toLowerCase();

	return airportCodeMap[airportCodeSlug] || airportCodeMap.iah; // Default to iah when it's the styleguide or gateway page
};
